// extracted by mini-css-extract-plugin
export default {"wrapper":"Eszd4","description":"Vs3pz","errors":"NwxCa"};